import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_TRACKER = "/api/material_assignments";
const RESOURCE_TRACKER_EMPLOYEE = "/api/employees";

export default {
  async getMaterials(params) {
    return await Api()
      .get(RESOURCE_TRACKER, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async getMaterialsEmployee(id, params) {
    return await Api()
      .get(RESOURCE_TRACKER_EMPLOYEE+'/'+id+'/materials', { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async createMaterial(params) {
    return Api()
      .post(RESOURCE_TRACKER, params)
      .catch((err) => errorHandler(err, null));
  },
  async confirmMaterial(id,params) {
    return Api()
      .post(RESOURCE_TRACKER+'/'+id+'/confirm', params)
      .catch((err) => errorHandler(err, null));
  },
  async returnMaterialEmployee(id,params) {
    return Api()
      .post(RESOURCE_TRACKER+'/'+id+'/return', params)
      .catch((err) => errorHandler(err, null));
  },
  async recieveMaterialEmployee(id,params) {
    return Api()
      .post(RESOURCE_TRACKER+'/'+id+'/receive', params)
      .catch((err) => errorHandler(err, null));
  },
  async completeReturnBySystems(id, params) {
    return Api()
      .post(RESOURCE_TRACKER+'/'+id+'/complete-return', params)
      .catch((err) => errorHandler(err, null));
  },
  async updateMaterial(id, params) {
    return Api()
      .put(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async getMaterial(id, params) {
    return Api()
      .get(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async discardMaterial(id) {
    return Api()
      .delete(`${RESOURCE_TRACKER}/${id}`)
      .catch((err) => errorHandler(err, null));
  },
};
